import { createApi } from '@reduxjs/toolkit/query/react';
import { AUTH_SERVICE } from 'utils/const';
import {
  authenticate,
  signup,
  login,
  logout,
  forgotPassword,
  forgotPasswordSubmit,
  resendSignUp,
} from './authApis';

export const authApi = createApi({
  reducerPath: 'authApi',
  baseQuery: async (args) => {
    const { path } = args;
    switch (path) {
      case AUTH_SERVICE.AUTHENTICATE:
        return authenticate(args);
      case AUTH_SERVICE.SIGN_UP:
        return signup(args);
      case AUTH_SERVICE.LOGIN:
        return login(args);
      case AUTH_SERVICE.LOGOUT:
        return logout(args);
      case AUTH_SERVICE.FORGOT_PASSWORD:
        return forgotPassword(args);
      case AUTH_SERVICE.FORGOT_PASSWORD_SUBMIT:
        return forgotPasswordSubmit(args);
      case AUTH_SERVICE.RESEND_SIGN_UP:
        return resendSignUp(args);
      default:
        return { error: 'path attribute is missing in the arguments!' };
    }
  },
  endpoints: (builder) => ({
    authenticate: builder.query({
      query: (args) => ({
        path: AUTH_SERVICE.AUTHENTICATE,
        ...args,
      }),
    }),
    signup: builder.mutation({
      query: (args) => ({
        path: AUTH_SERVICE.SIGN_UP,
        ...args,
      }),
    }),
    login: builder.mutation({
      query: (args) => ({
        path: AUTH_SERVICE.LOGIN,
        ...args,
      }),
      keepUnusedDataFor: 0,
    }),
    logout: builder.mutation({
      query: (args) => ({
        path: AUTH_SERVICE.LOGOUT,
        ...args,
      }),
    }),
    forgotPassword: builder.mutation({
      query: (args) => ({
        path: AUTH_SERVICE.FORGOT_PASSWORD,
        ...args,
      }),
    }),
    forgotPasswordSubmit: builder.mutation({
      query: (args) => ({
        path: AUTH_SERVICE.FORGOT_PASSWORD_SUBMIT,
        ...args,
      }),
    }),
    resendSignUp: builder.mutation({
      query: (args) => ({
        path: AUTH_SERVICE.FORGOT_PASSWORD_SUBMIT,
        ...args,
      }),
    }),
  }),
});

export const {
  useAuthenticateQuery,
  useSignupMutation,
  useLoginMutation,
  useLogoutMutation,
  useForgotPasswordMutation,
  useForgotPasswordSubmitMutation,
  useResendSignUpMutation,
} = authApi;
